import { AxiosResponse } from "axios";
import HttpService from "src/services/httpService";
import RouteService from "src/services/routeService";
import { PaginatedResponse } from "src/types";

import { unpackError } from "@dashboard/devices/api/helpers";

export async function fetchAllBuilds() {
    try {
        const endpoint = await RouteService.getProductRoute();
        const response: AxiosResponse<PaginatedResponse<API.AdminBuild>> = await HttpService.get(endpoint + "builds/queued");
        return response.data;
    } catch (error) {
        throw unpackError(error);
    }
}
